import { useDispatch, useSelector } from "react-redux";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import Loadable from "../../../components/loadable/Loadable";
import Popup from "../../../components/popup/Popup";
import styles from './BeneficiaryOwner.styles';
import { useEffect } from "react";
import { getBenefiaryOwnerFormFields, getBeneficiaryOwnerDetails, onDependentFieldChangeGetValues, submitBenefiaryOwner } from "./BeneficiaryOwnerSaga";
import { BOI_FORM_STEPS } from "../../boireportingsection/constants";
import { componentKey, setBeneficiaryDetailId, setFormFields, setFormsPreLoadedData, setHelpTextObj, setIsBenefiarySubmitSuccess, setIsErrorOccurred, setShowHelpPopup } from "./BeneficiaryOwnerSlice";
import RenderBoiFields from "../../boireportingsection/fileboi/components/RenderBoiFields";
import Button from "../../../components/button/Button";
import { BUTTON_TYPE } from "../../../components/button/constants";
import FormEventHandlers from "../../../../libs/utility/formeventhandlers/FormEventHandlers";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { BENEFICIAL_OWNER_LOADING_STATES, BENEFICIAL_OWNER_LOADING_STATES_MESSAGE_MAP } from "./constants";

export default function BeneficiaryOwner({
    isOpen = false, 
    onCloseCb = () => {}, 
    onFinalSubmitCb = ()=> {},
    payerDetailId = null, 
    formsPreLoadedDataFromParent = {}, 
    onDependentFields = {},
    beneficialOwnerDetailId = null,   
    formRecordId = 0,
}) {
    useGarbageCollector(componentKey);
    const { loadingState, formFields, isBenefiarySubmitSuccess, beneficiaryDetailId, formsPreLoadedData, isErrorOccurred, showHelpPopup, helpTextObj } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(beneficialOwnerDetailId){
            dispatch(getBeneficiaryOwnerDetails({
                beneficialOwnerDetailId: beneficialOwnerDetailId,
                formName: BOI_FORM_STEPS.BENEFICIAL_OWNER,
                formsPreLoadedData: formsPreLoadedDataFromParent,
            }))
        }else{
            dispatch(getBenefiaryOwnerFormFields({formName: BOI_FORM_STEPS.BENEFICIAL_OWNER, formsPreLoadedData: formsPreLoadedDataFromParent,}));
            dispatch(setFormsPreLoadedData(formsPreLoadedDataFromParent))
        }
    }, [])

    useEffect(() => {
        if(isErrorOccurred){
            onCloseCb();
            dispatch(setIsErrorOccurred(false));
        }
    }, [isErrorOccurred])

    useEffect(() => {
        if(isBenefiarySubmitSuccess){
            onFinalSubmitCb(beneficiaryDetailId);
            onCloseCb();
            dispatch(setIsBenefiarySubmitSuccess(null));
            dispatch(setBeneficiaryDetailId(0));
        }
    }, [isBenefiarySubmitSuccess])

    const handleSubmitBeneficiary = () => {
        let fieldsList = formFields;
       
        let validationResult = true;
            validationResult = FormEventHandlers.handleNextBtnClick(BOI_FORM_STEPS.BENEFICIAL_OWNER, fieldsList, false, (updatedFieldsList) => dispatch(setFormFields(updatedFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in fields.", message: "To continue, please resolve these errors" })), true);
        if (validationResult) {
            let finalFormObject = fieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});
            finalFormObject = {
                ...finalFormObject,
                PayerDetailId: payerDetailId,
                BeneficialOwnerDetailsId: beneficiaryDetailId,
                FormRecordId: formRecordId
            }
            dispatch(submitBenefiaryOwner({
                formData: { ...finalFormObject },
            }));
        }
        return false
    }

    return <>
        <Popup isPopupOpen={isOpen} title={"Beneficial Owner"} onCloseCb={onCloseCb} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
            <div style={styles.mainContainer}>
            <Loadable currentState={loadingState.state} loadingStates={[BENEFICIAL_OWNER_LOADING_STATES.CALCULATE_INFERRED_LOADING]} messageMap={BENEFICIAL_OWNER_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} preserveChildMount={true}>
                <Loadable currentState={loadingState.state} loadingStates={[BENEFICIAL_OWNER_LOADING_STATES.GRID_LOADING]} messageMap={BENEFICIAL_OWNER_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <div style={styles.fieldsContainer}>
                        <RenderBoiFields stepFields={formFields ?? []} updateFormFieldsCb={(updatedFieldsList) => dispatch(setFormFields(updatedFieldsList))} onDependentFieldChangeGetValuesCb={(onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData))} currentStep={BOI_FORM_STEPS.BENEFICIAL_OWNER} onDependentFields={onDependentFields} formsPreLoadedData={formsPreLoadedData} setShowHelpPopupCb={() => dispatch(setShowHelpPopup(true))} setHelpTextObjCb={(helpText) => dispatch(setHelpTextObj(helpText))} />
                    </div>
                    <div style={styles.submitBtnDivStyles}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => handleSubmitBeneficiary()}>Save Beneficial Owner</Button>
                    </div>
                </Loadable>
            </Loadable>
            </div>
        </Popup>
        {
            <Popup title={"Help"} onCloseCb={() => {dispatch(setShowHelpPopup(false)); dispatch(setHelpTextObj({}))}} showClose={true} isPopupOpen={showHelpPopup} customPopupSyles={styles.helpTextPopupStypes} customPopupHeaderStyles={styles.helpTextPopupHeaderStyles} childrenStyles={styles.helpTextChildrenStyles}>
                {
                    helpTextObj?.Value ? <iframe
                        key={helpTextObj?.Target ?? helpTextObj?.Value}
                        src={`${helpTextObj?.Value}${helpTextObj?.Target ?? ''}`}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                    />
                    : 
                    <div>Facing some error. Please try again.</div>
                }
                
            </Popup>
        }
    </>
}